import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "../../client/components/ui/button";
import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import useTranslation from "../../client/hooks/useTranslation";

interface MyLinkCardProps {
  profile: {
    refCode: string;
    commissionRate: number;
    commissionDurationMonths: number;
  };
  isDark: boolean;
}

const ATTRIBUTION_WINDOW_DAYS = 60;

export default function MyLinkCard({ profile, isDark }: MyLinkCardProps) {
  const t = useTranslation();
  const [copied, setCopied] = useState(false);

  const referralLink = `${window.location.origin}/?ref=${profile.refCode}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard indisponible : l'utilisateur peut sélectionner le texte
    }
  };

  const terms = t.affiliate.link.terms
    .replace("{rate}", String(Math.round(profile.commissionRate * 1000) / 10))
    .replace("{months}", String(profile.commissionDurationMonths))
    .replace("{days}", String(ATTRIBUTION_WINDOW_DAYS));

  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.affiliate.link.title} isDark={isDark} compact />
      <CardContent className="px-4 pb-4 pt-3 flex-1 flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <code className="flex-1 rounded-md border border-border bg-card px-3 py-2 font-mono text-xs break-all">
            {referralLink}
          </code>
          <Button size="sm" variant="outline" onClick={handleCopy}>
            {copied ? (
              <Check className="h-3.5 w-3.5 text-primary" aria-hidden />
            ) : (
              <Copy className="h-3.5 w-3.5" aria-hidden />
            )}
            <span className="ml-1.5">
              {copied ? t.affiliate.link.copied : t.affiliate.link.copy}
            </span>
          </Button>
        </div>
        <p className="text-xs leading-5 text-muted-foreground">{terms}</p>
      </CardContent>
    </Card>
  );
}
